import newsApi from "@/api/newsApi";

const newDetlState = atom({
  loadingDetl: false,
  isEmptyDetl: false,
  errMsgDetl: "",
  content: "",
  image: "",
  title: "",
  media: "",
  addtime: "",
  author: "",
  queryParams: {
    newsId: "",
  },
});

const useNewsDetlCtrl = () => {
  const [getNewsDetl, setNewsDetl] = useAtom(newDetlState);
  return {
    loadingDetl: getNewsDetl.loadingDetl,
    isEmptyDetl: getNewsDetl.isEmptyDetl,
    errMsgDetl: getNewsDetl.errMsgDetl,
    content: getNewsDetl.content,
    image: getNewsDetl.image,
    title: getNewsDetl.title,
    media: getNewsDetl.media,
    addtime: getNewsDetl.addtime,
    author: getNewsDetl.author,
    queryParams: getNewsDetl.queryParams,
    setNewsDetl,
  };
};

const useNewsDetlHook = () => {
  const { setNewsDetl, queryParams } = useNewsDetlCtrl();
  async function loadNewsDetl() {
    try {
      const res = await newsApi.queryDetail(queryParams);
      if (!isEmptyType(res?.data)) {
        setNewsDetl(prev => ({
          ...prev,
          loadingDetl: false,
          isEmptyDetl: false,
          errMsgDetl: "",
          content: res.data.about,
          image: res.data.image,
          title: res.data.title,
          media: res.data.media,
          addtime: res.data.addtime,
          author: res.data.author,
        }));
      } else {
        setNewsDetl(prev => ({
          ...prev,
          loadingDetl: false,
          isEmptyDetl: true,
          errMsgDetl: "",
        }));
      }
      return res;
    } catch (error) {
      console.error("Failed to fetch news-detl:", error);
      setNewsDetl(prev => ({
        ...prev,
        loadingDetl: false,
        isEmptyDetl: false,
        errMsgDetl: error instanceof Error ? error.message : "未知错误",
      }));
    }
  }

  return {
    loadNewsDetl,
  };
};
export { useNewsDetlHook, useNewsDetlCtrl };
